export interface Vehicle {
    id: number
    name: string
    modelName: string
    brand: string
    year: number
    rank: number
    type: string
    totalXp: number
    xpCost: number
    price: number
    inRace: boolean
    damage: VehicleDamageDto
}

export const areVehiclesEquals = (veh1: Vehicle | null, veh2: Vehicle | null): boolean => {
    if (veh1 === null && veh2 === null) return true
    if (veh1 === null || veh2 === null) return false
    return veh1.id === veh2.id && veh1.brand === veh2.brand && veh1.modelName === veh2.modelName && veh1.year === veh2.year && veh1.rank === veh2.rank && veh1.type === veh2.type && veh1.totalXp === veh2.totalXp && veh1.xpCost === veh2.xpCost && veh1.price === veh2.price && veh1.inRace === veh2.inRace && veh1.damage?.damage === veh2.damage?.damage && veh1.damage?.price === veh2.damage?.price
}

export interface VehicleDamageDto {
    damage: number
    price: number
}

export interface Handling {
    fmass: number
    finitialDragCoeff: number
    vecCentreOfMassOffsetX: number
    vecCentreOfMassOffsetY: number
    vecCentreOfMassOffsetZ: number
    vecInertiaMultiplierX: number
    vecInertiaMultiplierY: number
    vecInertiaMultiplierZ: number
    fdriveBiasFront: number
    ninitialDriveGears: number
    finitialDriveForce: number
    fdriveInertia: number
    fclutchChangeRateScaleUpShift: number
    fclutchChangeRateScaleDownShift: number
    finitialDriveMaxFlatVel: number
    fbrakeForce: number
    fbrakeBiasFront: number
    fhandBrakeForce: number
    fsteeringLock: number
    ftractionCurveMax: number
    ftractionCurveMin: number
    ftractionCurveLateral: number
    ftractionSpringDeltaMax: number
    flowSpeedTractionLossMult: number
    fcamberStiffnesss: number
    ftractionBiasFront: number
    ftractionLossMultiplier: number
    fsuspensionForce: number
    fsuspensionCompDamp: number
    fsuspensionReboundDamp: number
    fsuspensionUpperLimit: number
    fsuspensionLowerLimit: number
    fsuspensionRaise: number
    fsuspensionBiasFront: number
    fantiRollBarForce: number
    fantiRollBarBiasFront: number
    frollCentreHeightFront: number
    frollCentreHeightRear: number
    fcollisionDamageMult: number
    fweaponDamageMult: number
    fdeformationDamageMult: number
    fengineDamageMult: number
    fpetrolTankVolume: number
    foilVolume: number
    fpetrolConsumptionRate: number
    fseatOffsetDistX: number
    fseatOffsetDistY: number
    fseatOffsetDistZ: number
    nmonetaryValue: number
    strModelFlags: number
    strHandlingFlags: number
    fbackEndPopUpCarImpulseMult: number
    fbackEndPopUpBuildingImpulseMult: number
    fbackEndPopUpMaxDeltaSpeed: number
    ftoeFront: number
    ftoeRear: number
    fcamberFront: number
    fcamberRear: number
    feastor: number
    fengineResistance: number
    fmaxDriveBiasTransfer: number
    fjumpForceScale: number
    fincreasedRammingForceScale: number
    strAdvancedFlags: number
}